import StudentsScreen from './containers/studentsScreen'

export {default as StudentsScreenLayout} from './components/studentsScreenLayout'

export default StudentsScreen
